import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const location = useLocation();

  const projects = [
    { name: 'Cayalá', path: '/cayala' },
    { name: 'Azalea', path: '/project/azalea' },
    { name: 'Eonia', path: '/project/eonia' },
    { name: 'Nogales', path: '/project/nogales' },
    { name: 'Antares', path: '/project/antares' }
  ];

  const getSubNavItems = (projectName: string) => [
    { name: 'Información General', path: `/project/${projectName}` },
    { name: 'Brochure', path: `/project/${projectName}/brochure` },
    { name: 'Libro de Ventas', path: `/project/${projectName}/libro-ventas` },
    { name: 'Tour 3D', path: `/project/${projectName}/tour-3d` }
  ];

  const getCayalaSubNavItems = () => [
    { name: 'Información General', path: '/cayala' },
    { name: 'Brochure', path: '/cayala/brochure' },
    { name: 'Libro de Ventas', path: '/cayala/libro-ventas' },
    { name: 'Tour 3D', path: '/cayala/tour-3d' }
  ];

  const currentProject = location.pathname.split('/')[2];
  const isCayalaPage = location.pathname === '/cayala' || location.pathname === '/';
  const isCayalaSubRoute = location.pathname.startsWith('/cayala/');

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <div className="logo-icon">
              <img src="/logo-atrio.png" alt="Atrio Logo" className="logo-svg" />
            </div>
          </Link>
        </div>

        <nav className="main-nav">
          {projects.map((project) => (
            <Link
              key={project.name}
              to={project.path}
              className={`nav-item ${
                (project.name === 'Cayalá' && (isCayalaPage || isCayalaSubRoute)) || 
                (currentProject === project.name.toLowerCase()) ? 'active' : ''
              }`}
            >
              {project.name}
            </Link>
          ))}
        </nav>
      </div>

      {isCayalaSubRoute && (
        <div className="sub-nav">
          <div className="sub-nav-container">
            {getCayalaSubNavItems().map((item, index) => {
              // For Cayala subroutes, check if current path matches exactly, or if it's the first item for main routes
              const isActive = location.pathname === item.path || 
                              ((location.pathname === '/' || location.pathname === '/cayala') && index === 0);
              
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`sub-nav-item ${isActive ? 'active' : ''}`}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>
        </div>
      )}

      {currentProject && !isCayalaPage && (
        <div className="sub-nav">
          <div className="sub-nav-container">
            {getSubNavItems(currentProject).map((item, index) => {
              // Check if current path matches exactly, or if it's the base project path and this is the first item
              const isActive = location.pathname === item.path || 
                              (location.pathname === `/project/${currentProject}` && index === 0);
              
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`sub-nav-item ${isActive ? 'active' : ''}`}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
